<template lang="pug">
.container
    .row
        .col-md-12
            .alert.alert-info
                template(v-if="retailers.length > 1")
                    | {{ retailers.length }} retailers selected
                template(v-else-if="retailers.length === 1")
                    | {{ retailers.length }} retailer selected
                template(v-else)
                    | No retailer selected

        .col-md-12
            v-server-table(
                :url="url"
                :columns="columns"
                :options="options"
                :name="tableName"
                ref="datatable"
            )
                template(slot="beforeTable")
                    datatable-loader(:name="tableName")

                template(slot="select" slot-scope="props")
                    label.md-check
                        input(
                            type="checkbox"
                            :checked="checkedRetailers(props.row)"
                            @change="assignRetailers(props.row)"
                        )
                        i.indigo
</template>

<script>
const TableName = 'VUETABLE_SHELF_LABEL_RETAILERS';

import { mapGetters, mapMutations } from 'vuex';

export default {
    data() {
        return {
            tableName: TableName,
            columns: ['select', 'name', 'email'],
            options: {
                sortable: [],
            },
        };
    },

    computed: {
        ...mapGetters('shelfLabel', ['retailers']),

        ...mapGetters('override_pricebook', ['pricebook']),

        url() {
            let firstOutlet = this.pricebook.outlets
                .filter(data => typeof data !== undefined)
                .shift();

            return Laroute.route('franchise.shelf.label.retailers', {
                id: firstOutlet.id,
            });
        },
    },

    methods: {
        ...mapMutations('shelfLabel', ['assignRetailers']),

        checkedRetailers(row) {
            if (this.retailers) {
                return this.retailers.map(r => r.id).includes(row.id);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/shelf-labels/shelf-labels-retailers.vue